// Re-export auth from the config file
import { auth, db } from './config/firebase';
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';

// Explicitly type the exports
const typedAuth: Auth = auth;
const typedDb: Firestore = db;

export { typedAuth as auth, typedDb as db }; 